import React from 'react';
import './UserOption.css';

export const UserOptionComponent = ({name, index}) => {

    return (
        <option value={index} > {name} </option>
    )
}

export default UserOptionComponent;



// WEBPACK FOOTER //
// ./src/components/UserOption/UserOption.js